var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-form-group",
    {
      attrs: {
        "invalid-feedback": _vm.error,
        state: _vm.state,
        label: _vm.label,
        "label-for": "tinymce-editor-" + _vm.label
      }
    },
    [
      _vm.description
        ? _c("small", { staticClass: "form-text mb-2" }, [
            _vm._v(_vm._s(_vm.description))
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("editor", {
        key: _vm.timestamp,
        ref: "tinymceEditor",
        attrs: {
          id: "tinymce-editor-" + _vm._.snakeCase(_vm.label),
          init: _vm.editorConfig,
          "api-key": _vm.getKey()
        },
        on: { input: _vm.updateValue },
        model: {
          value: _vm.content,
          callback: function($$v) {
            _vm.content = $$v
          },
          expression: "content"
        }
      }),
      _vm._v(" "),
      _c("file-modal-component", {
        attrs: {
          show: _vm.showFileModal,
          extensions: _vm.extensions,
          closeModal: _vm.closeFileModal
        },
        on: { change: _vm.insertAsset }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-da0134ce", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-da0134ce","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./seventytwo/72cms-ui/src/components/form-elements/TinymceEditorComponent.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-da0134ce","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./seventytwo/72cms-ui/src/components/form-elements/TinymceEditorComponent.vue
// module chunks = 0